import React, { useMemo, useEffect } from "react";
import { Trackable } from "@dpdgroupuk/react-event-tracker";
import PropTypes from "prop-types";
import Header from "components/Header";
import Banner from "components/Banner";
import Cards from "components/Cards";
import HexagonContent from "components/HexagonContent";
import VideoSection from "components/VideoSection";
import TopContent from "../../components/TopContent";
import Vans from "./components/Vans";
import FloatingButton from "components/FloatingButton";
import driver1 from "assets/images/driver1.png";
import * as routes from "../../router/constants";

const VIDEO_SECTIONS = {
  heading: "Watch our film to see a day in the life of an Owner Driver",
  variant: "index",
  videoUrl: "https://www.youtube.com/embed/l_9eotejSec",
};

const HEXAGON_CONTENT = {
  driver1: {
    imageAlignment: "right",
    image: driver1,
    header: "Owner Driver",
    list: [
        "From £50K to £60K per route",
        "You are responsible for your own tax and insurance contributions",
    ],
    anchorId: "driver",
    color: "primary",
    link: routes.APPLY,
    buttonText: "How to apply",
  },
}

const TOP_CONTENT = {
  title: "DPDgroup is the largest parcel delivery network in Europe.",
  description: "By choosing to drive for DPD you'll have the chance to earn £50K to £60K in revenue and be joining an open and inclusive culture, where people have the opportunity to flourish and shape their own careers.",
}

export const Index = ({ pageId, windowWidth, urlCampaign }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const localContext = useMemo(
    () => ({
      page: "home",
      pageId,
      // ... more params in local context
    }),
    [pageId]
  );

  const bannerProps = useMemo(
    () => ({
      subtitle: ["become a DPD DRIVER and earn £50K to £60K revenue"],
      title: ["Choose DPD"],
      boldIndex: -1,
      subtitleBoldIndex: -1,
      top: "subtitle",
      banner: "banner1",
      windowWidth,
    }),
    [windowWidth]
  );

  return (
    <Trackable
      loadId="homePage"
      interfaceId="homeInterface"
      context={localContext}
    >
      <div className="index">
        <div className="hero-section">
          <Header active="home" urlCampaign={urlCampaign} />

          <Banner
            {...bannerProps}
          />
        </div>

        <TopContent
          {...TOP_CONTENT}
        />

        <Cards urlCampaign={urlCampaign} />

        <Vans windowWidth={windowWidth} />

        <HexagonContent
          {...HEXAGON_CONTENT.driver1}
          urlCampaign={urlCampaign}
        />

        <VideoSection
          urlCampaign={urlCampaign}
          {...VIDEO_SECTIONS}
        />

        <FloatingButton urlCampaign={urlCampaign} />
      </div>
    </Trackable>
  );
};

Index.propTypes = {
  pageId: PropTypes.string.isRequired,
  windowWidth: PropTypes.number.isRequired,
  urlCampaign: PropTypes.string,
};

Index.defaultProps = {
  urlCampaign: "",
};

export default Index;
